import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class DashboardService {
  fetchStatistics(storeId = "") {
    return axios.get(API_URL + `dashboard/statistics/${storeId}`, {
      headers: authHeader(),
    });
  }
  fetchDraftsResponseStatistics(storeId, days, physicalOrderStatus){
    return axios.get(API_URL + `dashboard/draft-statistics/${storeId}/${days}/${physicalOrderStatus}`, {
      headers: authHeader(),
    });
  }
  fetchOrderItemStatusStats(storeId, days){
    return axios.post(API_URL + `dashboard/order-status-statistics`, {shopifyStoreId: storeId, days}, {
      headers: authHeader(),
    });
  }
  fetchAverageDesignRatings(storeId, days){
    return axios.post(API_URL + `dashboard/get-average-of-designer-work-ratings`, {shopifyStoreId: storeId, days}, {
      headers: authHeader(),
    });
  }

  generateDraftResponseStats(storeId, days){
    return axios.post(API_URL + `draft-response-stats`, {storeId: storeId, days}, {
      headers: authHeader(),
    });
  }

}

export default new DashboardService();
